export const requiredFieldMessage = 'This field is required.';
export const requiredNumberFieldMessage =
  'This field is required and must be a number.';
